export default __webpack_public_path__ + "img/teaming-logo.0d3cd3e4.svg";